const fetchEquip = {
  text: 'no results found'
}

export default fetchEquip;
